import { Dayjs } from 'dayjs';
import { DayType, JobRole, ClubType } from '@app/models';
import { ClientScheduleDefaults } from '@app/interfaces';
import { ScheduleTypeConstants } from './constants';
import dayjs from 'dayjs';

export function getScheduleType(date: Dayjs, dayType: DayType, jobRole: Partial<JobRole> | null): string | null {
  let scheduleType: string | null = null;

  if (dayType === DayType.FullDay) {
    switch (date.weekday()) {
      case 1: scheduleType = ScheduleTypeConstants.Monday; break;
      case 2: scheduleType = ScheduleTypeConstants.Tuesday; break;
      case 3: scheduleType = ScheduleTypeConstants.Wednesday; break;
      case 4: scheduleType = ScheduleTypeConstants.Thursday; break;
      case 5: scheduleType = ScheduleTypeConstants.Friday; break;
    }
  } else if (dayType === DayType.AM) {
    scheduleType = ScheduleTypeConstants.Morning;
  } else if (dayType === DayType.PM) {
    scheduleType = ScheduleTypeConstants.Afternoon;
  }

  if (jobRole?.IsClubRole) {
    switch (jobRole.ClubType) {
      case ClubType.Before: scheduleType = ScheduleTypeConstants.ClubBefore; break;
      case ClubType.Mid: scheduleType = ScheduleTypeConstants.ClubMid; break;
      case ClubType.After: scheduleType = ScheduleTypeConstants.ClubAfter; break;
    }
  }

  return scheduleType;
}

function getScheduleDefault(scheduleType: string, clientScheduleDefaults: ClientScheduleDefaults[]) {
  return clientScheduleDefaults?.find(x => x.ScheduleType === scheduleType);
}

export function calculateStartTime(scheduleType: string, daySelectedType: DayType, clientScheduleDefaults: ClientScheduleDefaults[]): Dayjs {
    const scheduleDefault = getScheduleDefault(scheduleType, clientScheduleDefaults);
    if (scheduleDefault?.StartTime) {
      return dayjs(scheduleDefault.StartTime, 'hh:mm');
    }

    return [DayType.FullDay, DayType.AM].includes(daySelectedType)
      ? dayjs('08:30', 'hh:mm')
      : dayjs('12:30', 'hh:mm');
}

export function calculateEndTime(scheduleType: string, clientScheduleDefaults: ClientScheduleDefaults[]): Dayjs {
    const scheduleDefault = getScheduleDefault(scheduleType, clientScheduleDefaults);
    if (scheduleDefault?.EndTime) {
        return dayjs(scheduleDefault.EndTime, 'hh:mm');
    }
    return dayjs('15:30', 'hh:mm');
}
